<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch">
    <el-page-header @back="goback" style="margin-bottom: 20px">
      <template #content>
        <span class="text-large font-600 mr-3">{{ realname }} </span>
      </template>
    </el-page-header>
    <el-form-item label="年级">
        <el-select v-model="queryParam.grade" placeholder="选择年级" style="width: 100%;">
            <el-option
              v-for="item in gradeData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="学期">
          <el-select v-model="queryParam.semester" placeholder="选择学期" style="width: 100%;">
            <el-option
              v-for="item in semesterData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="班级">
          <el-select v-model="queryParam.classes" placeholder="选择班级" style="width: 100%;">
            <el-option
              v-for="item in classData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
    <el-form-item label="考试名称">
      <el-input v-model="queryParam.examname" placeholder="考试名称" />
    </el-form-item>
    
    <el-form-item>
      <el-button type="primary" @click="getListScore">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div class="mainTableTop">
        <el-button
          type="primary"
          @click="(dialog = true), doScoreAdd()"
          v-hasPermission="['score:add']"
          >新增成绩</el-button
        >
      </div>
    </el-col>
  </el-row>

  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-table ref="tableRef" v-loading="loadingData" :data="tableData" class="mainTable">
        <el-table-column prop="examname" label="考试名称"/>
        <el-table-column prop="examtime" label="考试时间"/>
        <el-table-column prop="grade" label="班级">
          <template #default="scope">
            {{ util.showGrade(scope.row.grade) }}（{{ util.showClass(scope.row.classes)}}）
          </template>
        </el-table-column>
        <el-table-column prop="years" label="年度">
          <template #default="scope">
            {{scope.row.years}}年度
          </template>
        </el-table-column>
        <el-table-column prop="semester" label="学期">
          <template #default="scope">
            <span
              v-text="
                util.showSemester(scope.row.semester)
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="school" label="学校" />
        <el-table-column prop="totalscore" label="总分" />
        <el-table-column prop="classhightotalscore" label="班高" />
        <el-table-column prop="gradehightotalscore" label="年高" />
        <el-table-column prop="classtotalrank" label="班排" />
        <el-table-column prop="gradetotalrank" label="年排" />
        <el-table-column prop="created" label="时间">
          <template #default="scope">
            <span
              v-text="
                util.formatDateUnix(scope.row.created, 'yyyy-MM-dd hh:mm')
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="160">
          <template #default="scope">

          <el-link
              type="primary"
              @click="open('score:view', scope.row)"
              v-hasPermission="['score:view1']"
              >详情</el-link>
            <el-link
            type="primary"
            @click="(dialog = true), doScoreEdit(scope.$index, scope.row)"
            v-hasPermission="['score:edit']"
            >编辑</el-link>

            <el-popconfirm
              confirm-button-type="primary"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定删除吗？"
              width="200px"
              @confirm="doScoreDelete(scope.$index, scope.row)"
            >
              <template #reference>
                <el-link
                  type="danger"
                  v-hasPermission="['score:delete']"
                  >删除</el-link
                >
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="8">
      <!-- <div>
        <el-button type="primary">新增成绩</el-button>
      </div> -->
    </el-col>
    <el-col :span="16">
      <div style="float: right">
        <el-pagination
          :hide-on-single-page="false"
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[10, 15, 20, 30]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
        />
      </div>
    </el-col>
  </el-row>

  <el-drawer
    ref="drawerRef"
    v-model="dialog"
    :title="title"
    direction="rtl"
    :close-on-click-modal="false"
    size="60%"
    @close="doScoreClose()"
  >
    <div class="common-drawer__content">
      <el-form
        ref="scoreFormRef"
        :model="scoreForm"
        :rules="rules"
        label-width="120px"
      >
      <h1>考生信息</h1>
      <el-form-item label="学校" prop="school">
          <el-input
            v-model.trim="scoreForm.school"
            placeholder="请输入学校全称，如何黄浦第一实验小学"
          ></el-input>
      </el-form-item>
      <el-form-item label="年级" prop="grade">
        <el-select v-model="scoreForm.grade" placeholder="选择年级" style="width: 100%;">
            <el-option
              v-for="item in gradeData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="学期" prop="semester">
          <el-select v-model="scoreForm.semester" placeholder="选择学期" style="width: 100%;">
            <el-option
              v-for="item in semesterData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="年度" prop="years">
          <el-select v-model="scoreForm.years" placeholder="选择年度" style="width: 100%;">
            <el-option
              v-for="item in yearData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="班级" prop="classes">
          <el-select v-model="scoreForm.classes" placeholder="选择班级" style="width: 100%;">
            <el-option
              v-for="item in classData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-divider />
        <h1>考试信息</h1>
        <el-form-item label="考试名称" prop="examname">
          <el-select v-model="scoreForm.examname" filterable clearable allow-create placeholder="选择考试名称或输入" style="width: 100%;">
            <el-option
              v-for="item in examnameData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="考试日期" prop="examtime">
          <el-date-picker
            v-model="scoreForm.examtime"
            type="date"
            placeholder="请选择考试日期"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            style="width: 100%;"
          />
        </el-form-item>
        <el-divider />
        <h1>科目信息</h1>
        <el-card
          class="box-card"
          shadow="never"
          style="margin-bottom: 10px"
          v-for="(subject, index) in scoreForm.scoreSubject"
          :key="subject.gsid"
        >
          <template #header>
            <div class="card-header">
              <span>科目信息({{ index + 1 }}）</span>
              <el-icon
                @click.prevent="deleteScoreSubject(subject)"
                style="float: right;cursor: pointer;"
                ><Close
              /></el-icon>
            </div>
          </template>
          <el-form-item
            label="科目名称"
            :prop="'scoreSubject.' + index + '.subjectname'"
            :rules="{
              required: true,
              message: '请选择科目名称 ',
              trigger: 'change',
            }"
          >
            <el-select
              style="width:100%"
              v-model="subject.subjectname"
              filterable
              clearable 
              allow-create 
              placeholder="请选择科目名称或者输入"
            >
              <template v-for="item in subjectData" :key="item.label">
                <el-option :label="item.label" :value="item.value" />
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="科目满分"
            :prop="'scoreSubject.' + index + '.fullmarks'"
            :rules="[{type:'number', message: '满分是数字', trigger: 'blur' }]"
          >
            <el-input
              v-model.number="subject.fullmarks"
              placeholder="请输入科目满分"
            />
          </el-form-item>
          <el-form-item
            label="成绩"
            :prop="'scoreSubject.' + index + '.score'"
            :rules="[{
              required: true,
              message: '请输入成绩',
              trigger: 'blur',
            },{ required: true, validator: validateDecimal, trigger: 'blur' }]"
          >
            <el-input
              v-model="subject.score"
              @blur="doAutoScore"
              placeholder="请输入成绩"
            />
          </el-form-item>
          <el-form-item
            label="班级排名"
            :prop="'scoreSubject.' + index + '.classrank'"
            :rules="[{
              required: true,
              message: '请输入班级排名',
              trigger: 'blur',
            },{ type: 'number', message: '排名是数字', trigger: 'blur' }]"
          >
            <el-input
              v-model.number="subject.classrank"
              placeholder="请输入班级排名"
            />
          </el-form-item>
          <el-form-item
            label="年级排名"
            :prop="'scoreSubject.' + index + '.graderank'"
            :rules="[{ type: 'number', message: '排名是数字', trigger: 'blur' }]"
          >
            <el-input
              v-model.number="subject.graderank"
              placeholder="请输入年级排名"
            />
          </el-form-item>
          <el-form-item
            label="班级最高分"
            :prop="'scoreSubject.' + index + '.classhighscore'"
            :rules="[{
              required: true,
              message: '请输入班级最高分',
              trigger: 'blur',
            },{ required: true, validator: validateDecimal, trigger: 'blur' }]"
          >
            <el-input
              v-model="subject.classhighscore"
              @blur="doAutoClasshighScore"
              placeholder="请输入班级最高分"
            />
          </el-form-item>
          <el-form-item
            label="班级最低分"
            :prop="'scoreSubject.' + index + '.classlowscore'"
            :rules="[{ validator: validateDecimal, trigger: 'blur' }]"
          >
            <el-input
              v-model="subject.classlowscore"
              @blur="doAutoClassLowScore"
              placeholder="请输入班级最低分"
            />
          </el-form-item>
          <el-form-item
            label="班级平均分"
            :prop="'scoreSubject.' + index + '.classavgscore'"
            :rules="[{ validator: validateDecimal, trigger: 'blur' }]"
          >
            <el-input
              v-model="subject.classavgscore"
              @blur="doAutoClassAvgScore"
              placeholder="请输入班级平均分"
            />
          </el-form-item>
          <el-form-item label="试卷" :prop="'scoreSubject.' + index + '.selfattachment'">
            <el-upload
              class="upload-demo"
              action="/api/upload/commonExampaper"
              :auto-upload="true"
              :headers="headerUpload"
              :data="{index:index}"
              :on-success="doUploadSuccess2"
              :before-upload="beforeUpload2"
              multiple
              v-model="fileList"
              ref="fileUpload2"
              accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/zip,application/pdf"
              name="picture"
            >
            <template #trigger>
              <el-button type="primary">选择附件（可多选）</el-button>
            </template>
            
              <template #tip>
                <div class="el-upload__tip">
                  请上传Word、Pdf、Zip后缀名且小于10M的文件。
                <template  v-for="(item, i) in fileList[index]" :key="i">
                  <div style="cursor: pointer;">
                    <el-link type="primary" @click="doDownload(item.name,item.url)">{{item.name}}</el-link> 
                    <el-icon :size="14" style="vertical-align: -2px; margin-left: 15px;" @click="deleteFileList(i, index)">
                      <Delete />
                    </el-icon>
                  </div>
                  
                </template>
                </div>
              </template>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="经验总结"
            :prop="'scoreSubject.' + index + '.note'"
          >
            <el-input
              v-model="subject.note"
              type="textarea"
              placeholder="请输入经验总结"
            />
          </el-form-item>
        </el-card>
        <div style="text-align: right;">
          <el-button @click="addScoreSubject" type="danger" style="text-align: right;">添加各科目成绩</el-button>
        </div>
        <el-divider />
        <h1>总分</h1>
        <el-form-item label="本人总分成绩" prop="totalscore">
          <el-input
            v-model.number="scoreForm.totalscore"
            placeholder="请输入本人总分成绩，若输入各科成绩，自动计算"
          ></el-input>
        </el-form-item>
        <el-form-item label="班级最高分" prop="classhightotalscore">
          <el-input
            v-model.number="scoreForm.classhightotalscore"
            placeholder="请输入班级最高分，若输入各科成绩，自动计算"
          ></el-input>
        </el-form-item>
        <el-form-item label="班级最低分" prop="classlowtotalscore">
          <el-input
            v-model.number="scoreForm.classlowtotalscore"
            placeholder="请输入班级最低分，若输入各科成绩，自动计算"
          ></el-input>
        </el-form-item>
        <el-form-item label="班级平均分" prop="classavgtotalscore">
          <el-input
            v-model.number="scoreForm.classavgtotalscore"
            placeholder="请输入班级平均分，若输入各科成绩，自动计算"
          ></el-input>
        </el-form-item>
        <el-form-item label="年级最高分" prop="gradehightotalscore">
          <el-input
            v-model.number="scoreForm.gradehightotalscore"
            placeholder="请输入年级最高分"
          ></el-input>
        </el-form-item>
        <el-divider />
        <h1>成绩排名</h1>
        <el-form-item label="班级排名" prop="classtotalrank">
          <el-input
            v-model.number="scoreForm.classtotalrank"
            placeholder="请输入班级排名"
          ></el-input>
        </el-form-item>
        <el-form-item label="年级排名" prop="gradetotalrank">
          <el-input
            v-model.number="scoreForm.gradetotalrank"
            placeholder="请输入年级排名"
          ></el-input>
        </el-form-item>
        <el-form-item label="区排名" prop="districttotalrank">
          <el-input
            v-model.number="scoreForm.districttotalrank"
            placeholder="请输入区排名"
          ></el-input>
        </el-form-item>
        <el-form-item label="市排名" prop="citytotalrank">
          <el-input
            v-model.number="scoreForm.citytotalrank"
            placeholder="请输入市排名"
          ></el-input>
        </el-form-item>
        <el-form-item label="省排名" prop="provincetotalrank">
          <el-input
            v-model.number="scoreForm.provincetotalrank"
            placeholder="请输入省排名"
          ></el-input>
        </el-form-item>
        <el-form-item label="国排名" prop="countrytotalrank">
          <el-input
            v-model.number="scoreForm.countrytotalrank"
            placeholder="请输入国排名"
          ></el-input>
        </el-form-item>
        <el-form-item label="经验总结" prop="totalnote">
          <el-input
            v-model="scoreForm.totalnote"
            placeholder="请输入经验总结"
            type="textarea"
          ></el-input>
        </el-form-item>

        

      </el-form>
      <div class="common-drawer__footer">
        <el-button @click="doScoreClose()">关闭</el-button>
        <el-button type="primary" :loading="loading" @click="doScoreSave">{{
          loading ? "提交中 ..." : "提交"
        }}</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script setup>
import { ref, onMounted, defineEmits } from "vue";//defineEmits
import { useRouter } from "vue-router";
import { ElDrawer, ElTable, ElMessage } from "element-plus";
import { listScore, deleteScore,saveScore  } from "@/api/score";
import { getShenshouInfo } from "@/api/shenshou";

import { downloadFile } from "@/api/common";

import util from "@/util/tool.js";
import storage from "@/util/storage.js";

import config from "@/util/config.js";


import store from "@/store";

let timer;

const dialog = ref(false);
const loading = ref(false);
const loadingData = ref(true);

const router = useRouter();
let open = (routeName, row) => {
  storage.saveSessionObject("scorePath",queryParam.value)
  router.push({
    name: routeName,
    params: { id: row.scoreid },
    query: { name: row.name },
  });
};

const drawerRef = ref(ElDrawer);

const tableData = ref();
const total = ref(0);
const pageSize = ref(15); //每页显示条数

let scoreFormRef = ref();
let title = ref("新增成绩");

const fileList = ref([[]])

const emit = defineEmits(["click"]); // 声明父触发事件

const gradeData = config.configGradeData
const classData = config.configClassData
const semesterData = config.configSemesterData
const examnameData = config.configExamNameData
const yearData = config.confgitYearDataReturn
const subjectData = config.configSubjectData
// console.log(gradeData)
// console.log(yearData)

const userid = ref(router.currentRoute.value.query.userid);
const realname = ref(router.currentRoute.value.query.realname);
const shenshouid = ref(router.currentRoute.value.params.id);

// console.log(userid,realname)


//onMounted方法
onMounted(() => {
  getListScore();
  doGetShenshouInfo()
});


//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  grade: "",
  classes: "",
  semester: "",
  examname: "",
  shenshouid: shenshouid.value
});
const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    grade: "",
    classes: "",
    semester: "",
    examname: "",
    shenshouid: shenshouid.value
  };
  getListScore();
};

//成绩表单项
let scoreForm = ref({
  scoreid: null,
  userid: userid.value,
  shenshouid: shenshouid.value ,
  school: "",
  grade: "",
  classes: "",
  semester: "",
  years: "",
  examname: "",
  examtime: "",
  totalscore: "",
  classhightotalscore: "",
  classlowtotalscore: "",
  classavgtotalscore: "",
  classtotalrank: "",
  gradehightotalscore: "",
  gradetotalrank: "",
  districttotalrank: "",
  citytotalrank: "",
  provincetotalrank: "",
  countrytotalrank: "",
  totalnote: "",

  scoreSubject: [{
    ssid:'',
    scoreid:'',
    subjectname:'',
    fullmarks: 100,
    score:'',
    classrank:'',
    graderank:'',
    classhighscore:'',
    classlowscore:'',
    classavgscore:'',
    gradehighscore:'',
    sourceattachment:'',
    selfattachment:'',
    note:'',
  }]
});

const doAutoScore = () => {
  let totalscore = 0
  scoreForm.value.scoreSubject.forEach((subject) => {
    totalscore += parseFloat(subject.score)
  });
  scoreForm.value.totalscore = totalscore
}

const doAutoClasshighScore = () => {
  let totalscore = 0
  scoreForm.value.scoreSubject.forEach((subject) => {
    totalscore += parseFloat(subject.classhighscore)
  });
  scoreForm.value.classhightotalscore = totalscore
}

const doAutoClassLowScore = () => {
  let totalscore = 0
  scoreForm.value.scoreSubject.forEach((subject) => {
    totalscore += parseFloat(subject.classlowscore)
  });
  scoreForm.value.classlowtotalscore = totalscore
}

const doAutoClassAvgScore = () => {
  let totalscore = 0
  scoreForm.value.scoreSubject.forEach((subject) => {
    totalscore += parseFloat(subject.classavgscore)
  });
  scoreForm.value.classavgtotalscore = totalscore
}

const addScoreSubject = () => {
  scoreForm.value.scoreSubject.push({
    scoreid:'',
    subjectname:'',
    fullmarks: 100,
    score:'',
    classrank:'',
    graderank:'',
    classhighscore:'',
    classlowscore:'',
    classavgscore:'',
    gradehighscore:'',
    sourceattachment:'',
    selfattachment:'',
    note:'',
  });
};
const deleteScoreSubject = (subject) => {
  const index = scoreForm.value.scoreSubject.indexOf(subject);
  if (index !== -1) {
    scoreForm.value.scoreSubject.splice(index, 1);
  }
};

//新增成绩
const doScoreAdd = () => {
  title.value = "新增成绩";
  fileList.value = []
};

//编辑成绩
const doScoreEdit = (index, obj) => {
  title.value = "编辑成绩";

  scoreForm.value = {
    scoreid: obj.scoreid,
    userid: obj.userid,
    shenshouid: obj.shenshouid,
    school: obj.school,
    grade: obj.grade,
    classes: obj.classes,
    semester: obj.semester,
    years: obj.years,
    examname: obj.examname,
    examtime: obj.examtime,
    totalscore: obj.totalscore,
    classhightotalscore: obj.classhightotalscore,
    classlowtotalscore: obj.classlowtotalscore,
    classavgtotalscore: obj.classavgtotalscore,
    classtotalrank: obj.classtotalrank,
    gradehightotalscore: obj.gradehightotalscore,
    gradetotalrank: obj.gradetotalrank,
    districttotalrank: obj.districttotalrank,
    citytotalrank: obj.citytotalrank,
    provincetotalrank: obj.provincetotalrank,
    countrytotalrank: obj.countrytotalrank,
    totalnote: obj.totalnote,
  };

  fileList.value = []
  let scoreSubjects = obj.scoreSubject;
  let dataTmp = [];
  scoreSubjects.forEach((subject,i) => {
    subject.scoreid = subject.scoreid.toString();
    subject.ssid = subject.ssid.toString();
    dataTmp.push(subject);

    if (subject.selfattachment) {
      fileList.value[i] = JSON.parse(subject.selfattachment)
    }

  });

  console.log(fileList.value)
  scoreForm.value.scoreSubject = dataTmp

};
const resetForm = () => {
  scoreForm.value = {
    scoreid: null,
    userid: userid.value,
    shenshouid: shenshouid.value,
    school: "",
    grade: "",
    classes: "",
    semester: "",
    years: "",
    examname: "",
    examtime: "",
    totalscore: "",
    classhightotalscore: "",
    classlowtotalscore: "",
    classavgtotalscore: "",
    classtotalrank: "",
    gradehightotalscore: "",
    gradetotalrank: "",
    districttotalrank: "",
    citytotalrank: "",
    provincetotalrank: "",
    countrytotalrank: "",
    totalnote: "",

    scoreSubject: [{
      ssid:'',
      scoreid:'',
      subjectname:'',
      fullmarks:'',
      score:'',
      classrank:'',
      graderank:'',
      classhighscore:'',
      classlowscore:'',
      classavgscore:'',
      gradehighscore:'',
      sourceattachment:'',
      selfattachment:'',
      note:'',
    }]
  };
};

//返回
const goback = () => {
  router.go(-1);
}

const shenshouInfo = ref();
const doGetShenshouInfo = () => {
  getShenshouInfo({ shenshouid: shenshouid.value }).then((res) => {
    let data = res.data.extend.shenshou;
    shenshouInfo.value = data
    scoreForm.value.school = data.school
    scoreForm.value.grade = data.grade
    scoreForm.value.classes = data.classes
  });
}

//关闭成绩表单弹窗
const doScoreClose = () => {
  loading.value = false;
  dialog.value = false;
  clearTimeout(timer);
  scoreFormRef.value.resetFields()
  resetForm();
};

//保存成绩数据
const doScoreSave = () => {
  scoreFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }
    console.log('-scoreForm.value',scoreForm.value)
    saveScore(scoreForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          getListScore();
          doScoreClose();
          resetForm();
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//更新成绩状态
const doScoreDelete = (index, obj) => {
  // console.log('obj.scoreid',obj.scoreid.toString())
  deleteScore(obj).then((res) => {
    // console.log(res);
    if (res.data.code === 1) {
      getListScore();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListScore();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListScore();
};

//成绩列表API
const getListScore = () => {
  listScore(queryParam.value).then((res) => {
    tableData.value = res.data.extend.pages.list;
    total.value = res.data.extend.pages.size;
    queryParam.value.pageSize = pageSize.value;
    loadingData.value = false
  });
};

const validateDecimal = (rule, value, callback) => {
  if (!value) { return true }
  //   const reg = /^d*(?:.d{0,2})?$/;
  const reg = /^(\d+\.?)?\d{0,2}$/;
  if (!String(value).match(reg)) {
    callback(new Error("只能填写整数、小数须保留两位小数"));
  } else {
    callback();
  }
};

//成绩表单验证规则
const rules = ref({
  school: [
    {
      required: true,
      message: "请输入学校名称",
      trigger: "blur",
    },
  ],
  grade: [
    {
      required: true,
      message: "请选择年级",
      trigger: "blur",
    },
  ],
  semester: [
    {
      required: true,
      message: "请选择学期",
      trigger: "blur",
    },
  ],
  classes: [
    {
      required: true,
      message: "请选择班级",
      trigger: "blur",
    },
  ],
  examname: [
    {
      required: true,
      message: "请输入考试名称",
      trigger: "blur",
    }
  ],
  examtime: [
    {
      required: true,
      message: "请选择考试时间",
      trigger: "blur",
    },
  ],
  totalscore: [
    {
      required: true,
      message: "请输入本人总分成绩",
      trigger: "blur",
    },
    { 
      required: true, 
      validator: validateDecimal, 
      trigger: 'blur' 
    }
  ],
  classhightotalscore: [
    {
      required: true,
      message: "请输入班级最高分",
      trigger: "blur",
    },
    { 
      required: true, 
      validator: validateDecimal, 
      trigger: 'blur' 
    }
  ],
  classlowtotalscore: [
    { 
      //required: true, 
      validator: validateDecimal, 
      trigger: 'blur'
    }
  ],
  classavgtotalscore: [
    { 
      //required: true, 
      validator: validateDecimal, 
      trigger: 'blur'
    }
  ],
  gradehightotalscore: [
    { 
      //required: true, 
      validator: validateDecimal, 
      trigger: 'blur'
    }
  ],
  classtotalrank: [
    {
      required: true,
      message: "请输入班级排名",
      trigger: "blur",
    },
    {
      type: 'number',
      message: "排名是数字",
      trigger: "blur",
    },
  ],
  gradetotalrank: [
    {
      required: true,
      message: "请输入年级排名",
      trigger: "blur",
    },
    {
      type: 'number',
      message: "排名是数字",
      trigger: "blur",
    },
  ],
  districttotalrank: [
    {
      type: 'number',
      message: "排名是数字",
      trigger: "blur",
    },
  ],
  citytotalrank: [
    {
      type: 'number',
      message: "排名是数字",
      trigger: "blur",
    },
  ],
  provincetotalrank: [
    {
      type: 'number',
      message: "排名是数字",
      trigger: "blur",
    },
  ],
  countrytotalrank: [
    {
      type: 'number',
      message: "排名是数字",
      trigger: "blur",
    },
  ],
  
});

function addObjectToRow(rowIndex, newObj) {
  // 在指定行添加一个新对象
  if (!fileList.value[rowIndex]) {
    fileList.value[rowIndex] = []; // 如果不存在，初始化为一个空数组
  }
  // 在指定行添加一个新对象
  fileList.value[rowIndex].push(newObj);
}

const filefail2 = ref("");
const resultMsg2 = ref();
const fileUpload2 = ref();
const doUploadSuccess2 = (response) => {  
  if (response.code === 0) {    
    ElMessage.error(response.msg)
  } else {
    resultMsg2.value = response.msg
    filefail2.value = response.url
    let index = response.index
    let obj = {name:response.name,size:response.size,url:response.url,type:response.type}

    console.log('---index---',index)

    addObjectToRow(index, obj);
    // fileList.value[index].push(obj);

    console.log('---fileList',JSON.stringify(fileList.value[index]))
    scoreForm.value.scoreSubject[index].selfattachment = JSON.stringify(fileList.value[index])
    setTimeout(function(){
      fileUpload2.value.clearFiles()
    },1000)
  }
};
const resultMsg = ref()
const beforeUpload2 = (rawFile) => {
  if (rawFile.type !== 'application/msword' && rawFile.type !=='application/vnd.openxmlformats-officedocument.wordprocessingml.document' && rawFile.type !=='application/zip' && rawFile.type !=='application/pdf') {
    ElMessage.error('请上传Word、Pdf、Zip格式文件!')
    return false
  } else if (rawFile.size / 1024 / 1024 > 10) {
    ElMessage.error('请上传小于10MB的文件!')
    return false
  }
  resultMsg.value = '正在上传处理中，请勿关闭或跳转页面！'
  return true
}
//删除附件
const deleteFileList = (i,index) => {
  fileList.value[index].splice(i,1)
  scoreForm.value.scoreSubject[index].selfattachment = JSON.stringify(fileList.value[index])
}

const headerUpload = ref({
  Authorization: store.state.user.token,
});

const doDownload = (filename, url) => {
  let data = {filename,url}
  downloadFile(data).then((response) => {
    const content = response.data;
    const blob = new Blob([content], {
      type: "application/octet-stream"
    });
    const downloadElement = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = decodeURI(response.headers["filename"]);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
    emit("click");
  });
}

</script>
<style scoped>
.checkAll {
  padding-left: 20px;
    border-bottom: 1px solid #f4f4f4;
    display: flex;
}
</style>
